module.exports = __webpack_public_path__ + "static/media/corner-logo.028d44a9.png";